module.exports = __webpack_public_path__ + "static/media/new-order-illustration.a1a359db.svg";